import '/src/css/overrides/grid-component.pcss';

import { defineComponent} from 'vue';

import GridComponent from '/src/vue/components/GridComponent.ts';

export default defineComponent({
  delimiters: ['${', '}'],
  components: {
    GridComponent,
  },
  data() {
    return {
      columns: [
        {
          id: 'order',
          name: 'Order Reference',
        },
        {
          id: 'date',
          name: 'Date of Order',
        },
        {
          id: 'total',
          name: 'Total Value',
        },
      ],
      sort: false,
      search: {
        keyword: '',
      },
      pagination: {
        enabled: true,
        limit: 5,
        summary: false,
      },
      loading: true,
    };
  },
  computed: {
    data() {
      return this.$store.getters.orderHistory;
    },
  },
  watch: {
    data() {
      this.loading = false;
      this.updateGridComponent();
    },
  },
  mounted() {
    if (this.data.length) {
      this.loading = false;
      this.updateGridComponent();
    }
  },
  methods: {
    updateGridComponent() {
      this.$refs.GridComponent.updateGridComponent({
        data: this.data,
      });
    },
    /**
     * Used at this component level for filtering the table results
     */
    searchData() {
      // Get the value of the component's search input
      const { value } = this.$refs.input;
      // Get the search data property value
      const { search } = this;
      // Set the property required for searching the grid component
      search.keyword = value;
      // Update the grid component with new search property
      this.$refs.GridComponent.updateGridComponent({
        search,
      });
    },
  },
  template: '#t-customer-order-history',
});
